import React from 'react';
import { BaseModal, CloseIcon, Divider, Text, View } from '@upstox/upstox-ui';
import PlatformService from 'modules/Platform';
import * as css from './styles';
import './modal.css';

const root: HTMLElement = window.document.getElementById('modalRoot')!;

type TModal = {
  title: string | React.ReactNode
  onClose: () => void;
  styles?: CSSFunction<any>;
}

const Modal: React.FC<TModal> = ({ children, title, onClose, styles }) => {
  const titleDom = (
    <View justifyContent="space-between" padding="xlarge" alignItems="center">
      <Text weight="bold" family="tvFont">{title}</Text>
      <View>
        <CloseIcon size="xxlarge" css={css.closeIcon} onClick={onClose} />
      </View>
    </View>
  );

  const mergedCSS: CSSFunction = (args) => ({
    ...css.base(args),
    ...(styles ? styles(args) : {}),
  });

  return (
    <BaseModal
      zIndex={20}
      container={root}
      onClose={onClose}
      className="base-modal"
    >
      <View
        flexDirection="column"
        css={mergedCSS}
        cssProps={{ fullScreen: PlatformService.isMobile }}
      >
        {titleDom}
        <Divider />
        {children}
      </View>
    </BaseModal>
  );
};

export default Modal;
